export const getItemByPartNumber: <T extends { partNumber?: string }>(
  partNumber: string,
  items: T[]
) => T | undefined = (partNumber, items) => {
  return items?.find((item) => item.partNumber === partNumber);
};

export const getFitmentData = (
  fitmentData: {
    [key: string]: {
      isSerialRangeCompatible: boolean;
      isSerialCompatible: boolean;
    };
  },
  partNumber: string
) => {
  return (
    fitmentData?.[partNumber] ?? {
      isSerialCompatible: false,
      isSerialRangeCompatible: false
    }
  );
};

export const checkObjectDeepEqual: <T>(obj1: T, obj2: T) => boolean = (
  obj1,
  obj2
) => {
  if (obj1 === obj2) return true;
  if (
    typeof obj1 !== 'object' ||
    typeof obj2 !== 'object' ||
    obj1 == null ||
    obj2 == null
  ) {
    return false;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) return false;
  for (const key of keys1) {
    if (!keys2.includes(key) || !checkObjectDeepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }
  return true;
};
